import createStyles from '@material-ui/core/styles/createStyles';
const styles = theme => createStyles({
  avatar: {
    margin: 'auto'
  },
  userName: {
    marginTop: theme.spacing(3),
    marginRight: theme.spacing(1),
  },

  birthDay: {
    marginTop: theme.spacing(2),
    marginRight: theme.spacing(1),
    color: '#00FFFF'
  },

  root: {
    flexGrow: 1,
    padding: 0
  },
  appBar: {
    position: 'fixed'
  },
  grow: {
    flexGrow: 1,
  },
  search: {
    position: 'relative',
    borderRadius: theme.shape.borderRadius,
    backgroundColor: theme.palette.common.white,
    color: theme.palette.common.black,
    marginRight: theme.spacing(),
    marginLeft: theme.spacing(),
    width: '30%',
    [theme.breakpoints.down('sm')]: {
      width: 'auto'
    }
  },
  searchIcon: {
    width: theme.spacing() * 3,
    pointerEvents: 'none',
    marginLeft: theme.spacing(),
    [theme.breakpoints.down('sm')]: {
      marginLeft: 0
    }
  },
  adornment: {
    [theme.breakpoints.down('sm')]: {
      marginLeft: 0
    }
  },
  titlelabelform: {
    color: '#2196f3',
    fontSize: '0.9rem',
    fontWeight: 'bold',
    marginLeft: theme.spacing(5),
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(2),
  },
  valuelabelform: {
    borderSpacing: 2,
    borderBottom: 0,
    color: '#6e6e6e',
    fontSize: '0.7rem',
    fontWeight: 'bold',
    verticalAlign: 'top',
  },
  link: {
    textDecoration: 'none',
  },
  inputRoot: {
    color: 'inherit',
    width: '100%',
    border: '0 !important'
  },
  paperMenu: {
    flexGrow: 1,
    padding: 0,
    width: 205,
    backgroundColor: 'white',
    borderRadius: 4,
    display: 'solid',
    boxShadow: '0px 1px 3px 0px rgba(0,0,0,0.2), 0px 1px 1px 0px rgba(0,0,0,0.14), 0px 2px 1px -1px rgba(0,0,0,0.12)',
  },
  textField: {
    width: '94%',
    paddingLeft: '2%'
  },
  inputInput: {
    paddingTop: theme.spacing(),
    paddingBottom: theme.spacing(),
    paddingLeft: theme.spacing(),
    paddingRight: theme.spacing(),
    transition: theme.transitions.create('width'),
    width: '80%',
    [theme.breakpoints.down('sm')]: {
      width: '100%',
      paddingRight: 0
    }
  },
  iconContainer: {
    display: 'flex'
  },
  iconFavorite: {
    color: 'white'
  }
});

export default styles;